import React from 'react';
import { TableDataCase } from '../TableDataCase';
import { Divider } from '../../../../atoms/Dividers/Divider';
import { ElevesDashboard } from '../../../../../types/classe/maClasse';
import { sanitizePrice } from '../../../../../helpers/number/sanitizeCalul';

export interface TableDataLineVentesProps {
  variant?: 'default' | 'warning';
  eleve: ElevesDashboard;
  unPayedCa: number;
  toElevePage: () => void;
}

export const TableDataLineVentes = ({
  variant = 'default',
  eleve,
  unPayedCa,
  toElevePage
}: TableDataLineVentesProps) => {
  const note = eleve.note;
  if (!note) return null;

  const caseColor = variant === 'default' ? 'normal' : 'orange';

  return (
    <>
      <tr>
        <TableDataCase
          variant={'data'}
          color={caseColor}
          data={`${eleve?.lastname} ${eleve?.firstname}`}
        />
        <TableDataCase
          variant={'data'}
          color={caseColor}
          data={`${sanitizePrice(note.qteca.toString())} €`}
        />
        <TableDataCase
          variant={'data'}
          color={caseColor}
          data={`${sanitizePrice(unPayedCa.toString())} €`}
        />
        <TableDataCase
          variant={'data'}
          color={caseColor}
          data={note.qtevente.toString()}
        />
        <TableDataCase
          variant={'data'}
          color={caseColor}
          data={note.qtepro.toString()}
        />
        <TableDataCase
          variant={'data'}
          color={caseColor}
          data={note.qterebond.toString()}
        />
        <TableDataCase
          onClick={toElevePage}
          color={caseColor}
          variant={'icon'}
          icon={'Form'}
        />
      </tr>
      <Divider color={'light'} margin={false} />
    </>
  );
};
